/**
 * Copy of the "Devenir formateur" page (French marketplace).
 * Update COMMISSION and PAYOUT_DELAY here when the terms change (see the CGV).
 */

export const COMMISSION = '16 % TTC';
export const PAYOUT_DELAY = '7 jours';

export const HERO = {
  kicker: 'Pour les formateurs',
  title: 'Remplissez vos sessions de formation, sans courir après les élèves',
  lead:
    "Publiez vos formations sur Formabel, la plateforme belge des formations courtes. On s'occupe de la visibilité, des réservations et du paiement. Vous, vous formez.",
  cta: 'Publier ma première formation',
  trust: ['Inscription gratuite', 'Paiement sécurisé par Stripe', 'Élèves partout en Belgique'],
};

export const STATS = [
  { value: '0 €', label: 'pour créer votre compte et publier' },
  { value: COMMISSION, label: 'de commission, seulement quand vous vendez' },
  { value: `~${PAYOUT_DELAY}`, label: 'après la réservation pour être payé' },
  { value: '3x', label: 'paiement en 3 fois possible pour vos élèves' },
];

export const BENEFITS = [
  {
    icon: '📣',
    title: 'Plus de visibilité',
    text:
      'Vos formations apparaissent dans la recherche Formabel, dans le blog des métiers et sur Google.',
  },
  {
    icon: '💳',
    title: 'Paiement garanti',
    text: "L'élève paie en ligne au moment de la réservation. Fini les impayés et les relances.",
  },
  {
    icon: '📅',
    title: 'Vos sessions, vos règles',
    text: 'Vous fixez vos dates, votre prix, votre lieu et le nombre de places.',
  },
  {
    icon: '🧾',
    title: 'Plus de réservations',
    text:
      'Vos élèves peuvent payer en 3 fois avec Scalapay : une formation à 600 € devient beaucoup plus facile à réserver.',
  },
  {
    icon: '📊',
    title: 'Un tableau de bord clair',
    text: 'Vos réservations, vos sessions à venir et vos revenus, au même endroit.',
  },
  {
    icon: '💬',
    title: 'Messagerie intégrée',
    text: 'Échangez avec vos élèves avant la formation, directement sur Formabel.',
  },
];

export const STEPS = [
  {
    title: 'Créez votre compte formateur',
    text: 'Gratuit, en 2 minutes. Présentez-vous et ajoutez votre photo.',
  },
  {
    title: 'Publiez votre formation',
    text: 'Programme, photos, dates, prix et nombre de places.',
  },
  {
    title: 'Recevez vos élèves',
    text: `Ils réservent et paient en ligne. Vous recevez votre paiement environ ${PAYOUT_DELAY} après la réservation.`,
  },
];

export const ROLES = {
  trainer: {
    title: 'Vous',
    items: [
      'Vous créez votre programme',
      'Vous fixez vos dates et votre prix',
      'Vous animez la formation',
    ],
  },
  formabel: {
    title: 'Formabel',
    items: [
      'Fait connaître vos formations',
      'Gère les réservations et les places',
      'Encaisse les paiements, y compris en 3 fois',
      'Vous verse votre part',
    ],
  },
};

// Real trainer reviews from Trustpilot (fr.trustpilot.com/review/formabel.be), quoted verbatim
export const TRUSTPILOT_URL = 'https://fr.trustpilot.com/review/formabel.be';
export const TESTIMONIALS = [
  {
    text:
      "Je suis très satisfaite de mon expérience avec FormaBel. Je propose mes formations via leur plateforme et tout se déroule parfaitement bien. L'organisation est claire, le suivi est sérieux et l'équipe est professionnelle. C'est un vrai plaisir de collaborer avec eux. Je recommande sans hésitation !",
    author: 'La Clinic Brussels',
    trade: 'formatrice',
  },
  {
    text:
      'Superbe plateforme pour mettre en évidence mes formations en esthétique automobile. Merci Nacim et son équipe.',
    author: "Nathan d'Ultimate Care",
    trade: 'formateur en esthétique automobile',
  },
  {
    text: 'Super, la meilleure plateforme ❤️',
    author: 'Rodrigues',
    trade: 'formatrice',
  },
];

export const FAQ = [
  {
    q: 'Combien coûte Formabel ?',
    a: `L'inscription et la publication sont gratuites. Formabel prélève une commission de ${COMMISSION} sur chaque réservation, uniquement quand vous vendez. Pas d'abonnement.`,
  },
  {
    q: 'Quand suis-je payé ?',
    a: `Le paiement est encaissé en ligne à la réservation, puis vous est versé sur votre compte bancaire, en général environ ${PAYOUT_DELAY} après la réservation.`,
  },
  {
    q: 'Qui fixe le prix de la formation ?',
    a: 'Vous. Vous choisissez votre prix, vos dates, votre lieu et le nombre de places.',
  },
  {
    q: 'Quelles formations puis-je proposer ?',
    a:
      'Des formations courtes et pratiques : esthétique, bâtiment, automobile, coiffure, bien-être, horeca et barista, photo et vidéo, business, bijouterie et horlogerie, et plus.',
  },
  {
    q: 'Faut-il un statut particulier ?',
    a: 'Vous devez pouvoir facturer vos formations, en tant qu’indépendant ou via votre société.',
  },
];

export const FINAL_CTA = {
  title: 'Prêt à transmettre votre savoir-faire ?',
  text: "Publiez votre première formation aujourd'hui. C'est gratuit.",
  cta: 'Devenir formateur',
};
